import React, { createContext, useCallback, useContext, useRef } from 'react';

export function initializeStateDispatchWrapperContext(StateContext) {
  const StateDispatchWrapperContext = createContext();

  function useStateDispatchWrapper() {
    return useContext(StateDispatchWrapperContext);
  }

  return {
    Provider: createProvider({ StateContext, StateDispatchWrapperContext }),
    Context: StateDispatchWrapperContext,
    useStateDispatchWrapper,
  };
}

function createProvider({ StateContext, StateDispatchWrapperContext }) {
  return function StateDispatchWrapperContextProvider ({ children }) {
    const state = useContext(StateContext.State);
    const dispatch = useContext(StateContext.Dispatch);

    const stateRef = useRef(state);
    const dispatchRef = useRef(dispatch);

    stateRef.current = state;
    dispatchRef.current = dispatch;

    const stateDispatchWrapper = useCallback((callback) => {
      return function(...args) {
        return callback(...args, { state: stateRef.current, dispatch: dispatchRef.current });
      };
    }, [dispatchRef]);

    return <StateDispatchWrapperContext.Provider value={stateDispatchWrapper}>
      {children}
    </StateDispatchWrapperContext.Provider>;
  };
}
